import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '@/shared/api/api';
import { UserService } from '@/shared/api/protocol-ts/api/core/svc_user_connectweb';
import {
  SetUserLanguageReq,
  SetUserLanguageResp,
  SetUserNameReq,
  SetUserNameResp,
} from '@/shared/api/protocol-ts/api/core/svc_user_pb';
import { LocalStorageKey, SliceName } from '@/shared/config';
import { createThunkGenerator } from '@/shared/lib';

import { UserLocalSettings } from '../lib/getInitialUserSettings';

import { actions } from './userSlice';

type UserRequests = keyof typeof UserService.methods;

const generateAccessThunk = createThunkGenerator<UserRequests>(SliceName.user);

export const setSettings = createAsyncThunk(
  'user/setSettings',
  async (settings: Partial<UserLocalSettings>) => {
    Object.entries(settings).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
    return settings;
  },
);

export const setUserLanguage = generateAccessThunk<
  SetUserLanguageReq,
  SetUserLanguageResp
>('setUserLanguage', api.user.setUserLanguage);

export const setUserName = generateAccessThunk<SetUserNameReq, SetUserNameResp>(
  'setUserName',
  api.user.setUserName,
);

export const setUserLocaleWithStorage = createAsyncThunk(
  'user/setUserLocaleWithStorage',
  async (locale: string | undefined, { dispatch }) => {
    if (locale) {
      localStorage.setItem(LocalStorageKey.unauthenticatedLocale, locale);
    }

    dispatch(actions.setUserLocale(locale));
  },
);
